module.exports = __webpack_public_path__ + "img/mansorahospital.3788a969.jpg";